import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    overflow: 'hidden',
  },

  image: {
    background: 'linear-gradient(90deg, rgb(95 87 87) 0%, rgb(66, 66, 66) 100%)',
  },

  image_light: {
    background: 'linear-gradient(270deg, rgb(255 255 255) 0%, rgb(215 215 215) 100%)',
  },
  paper: {
    margin: theme.spacing(6, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    cursor: 'pointer',
    width: 'auto',
    height: '130px',
  },

  logo: {
    height: '80px',
    width: 'auto',
  },

  form: {
    width: '95%',
    background: '#4b4b4b',
    padding: '18px',
    borderRadius: '5px',
    '& .MuiOutlinedInput-input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.mainDark} inset`,
      borderRadius: 'initial',
    },

    '& .MuiFormControl-marginNormal': {
      margin: `${theme.spacing(1)} 0`,
    },
  },

  submit: {
    margin: theme.spacing(3, 0, 2),
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
  },
  loginInfo: {
    textDecoration: 'none',
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
  },
  register: {
    textDecoration: 'none',
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  mediaLinks: {
    marginBottom: theme.spacing(1),
  },

  connector_image: {
    height: '70vh',
    alignSelf: 'self-end',
    opacity: '70%',
  },

  errorText: {
    textDecoration: 'none',
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
  },

  infoText: {
    textDecoration: 'none',
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    background: theme.palette.accents.dark,
  },

  disclaimer_text: {
    fontSize: '0.7rem !important',
    fontStyle: 'italic',
    lineHeight: 1,
    maxWidth: '80%',
    margin: '8px 0',
    backgroundColor: '#5e6263',
    padding: '4px',
  },

  logosContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    height: '100px',
    backgroundColor: '#b3b3b3',
    borderRadius: '5px',
    overflow: 'visible',
    padding: '18px',
  },

  form_login: {
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiOutlinedInput-input:-webkit-autofill': {
      WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.mainDark} inset`,
      borderRadius: 'initial',
    },
  },
  avatar_login: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
    width: 'auto',
    height: '20vh',
  },
  text_field_login: {
    width: '80%',
  },
  submit_login: {
    margin: theme.spacing(3, 0, 2),
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    width: '180px',
  },

  serverInfo: {
    marginTop: 14,
    width: '100%',
    height: '32px',
    display: 'flex',
    fontSize: theme.fonts?.responsiveSmall || '0.75rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    background: theme.palette.accents.main,
    minHeight: 'fit-content',
  },
}));
